module.exports = __webpack_public_path__ + "static/media/icons-ic-notifications-decline.d6f0dd7f.svg";